import React from 'react';
import { HeroVariant44 } from '../components/HeroVariant44';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage44() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1668">
      {/* Navigation is intentionally omitted here because it is built into HeroVariant44 */}
      <main data-id="element-1669">
        <HeroVariant44 data-id="element-1670" />
        <WhyUs data-id="element-1671" />
        <Services data-id="element-1672" />
        <FAQ data-id="element-1673" />
        <Testimonials data-id="element-1674" />
        <Consultation data-id="element-1675" />
      </main>
      <Footer data-id="element-1676" />
      <CookieBanner data-id="element-1677" />
      <FloatingContact data-id="element-1678" />
    </div>;
}